import React from "react";
import DoctorCard from "./DoctorCard";
import Apache from "../Assets/apache.webp"
import ESB from "../Assets/esb-logo.png"
import OracleFusion from "../Assets/oracle-fusion.png"
import RabbitMQ from "../Assets/rabbitmq.png"
import Kafka from "../Assets/kafka.webp"
import WebLogic from "../Assets/weblogic.webp"
import Nginx from "../Assets/nginx.webp"
import "../Styles/Doctors.css";
import Marquee from "react-fast-marquee";

function Middlewares() {
  return (
    <div className="doctor-section" id="middlewares">
      <div className="dt-title-content">
        <h3 className="dt-title">
          <span>Middlewares</span>
        </h3>

        <p className="dt-description">
          Meet our exceptional team of Middleware Systems Specialists, dedicated to
          providing top-notch technical & support services at TechiesHub. Trust in their
          knowledge and experience to lead you towards a reaching your goals.
        </p>
      </div>

        <Marquee
            speed={100}
            pauseOnHover={true}
            direction={"right"}
        >
            <DoctorCard
                img={WebLogic}
                name="WebLogic Server"
                stars="4.8"
                reviews="700"
            />
            <DoctorCard
                img={OracleFusion}
                name="Oracle Fusion"
                stars="4.7"
                reviews="450"
            />
            <DoctorCard
                img={Kafka}
                name="Kafka"
                stars="4.8"
                reviews="500"
            />
            <DoctorCard
                img={RabbitMQ}
                name="Messaging"
                title="Messaging Queue"
                stars="4.8"
                reviews="500"
            />
            <DoctorCard
                img={ESB}
                name="ESB"
                title="Enterprise Service Bus"
                stars="4.8"
                reviews="500"
            />
            <DoctorCard
                img={Nginx}
                name="Nginx"
                title="Nginx Proxy Server"
                stars="4.8"
                reviews="500"
            />
            <DoctorCard
                img={Apache}
                name="Apache"
                title="Apache HTTP Server"
                stars="4.8"
                reviews="500"
            />
        </Marquee>
    </div>
  );
}

export default Middlewares;
